import { render } from "./HandleDialog.vue?vue&type=template&id=6d5f62f1"
import script from "./HandleDialog.vue?vue&type=script&lang=js"
export * from "./HandleDialog.vue?vue&type=script&lang=js"

import "./HandleDialog.vue?vue&type=style&index=0&id=6d5f62f1&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__